<app-breadcrumb
  *ngIf="breadcrumbNodes.length > 0"
  [nodes]="breadcrumbNodes"
  [showMenu]="false"
  [root]="root"
  (nodeClicked)="onBreadcrumbClicked($event)"
>
</app-breadcrumb>
